import React from 'react';
import classnames from 'classnames';
import { SLIDE, EYE_TYPE_TOGGLE } from './config';

export type ButtonProps = {
  disabled: boolean;
  className: string;
  onKeyPress: <T>(type: Symbol, value: T) => void;
  type: Symbol;
  eyeType: string;
  value: string | React.ReactElement;
  children: React.ReactElement | string;
}

export default function Button(props: ButtonProps) {
  // const [keyStatus, setKeyStatus] = React.useState<boolean>(false);
  const [active, setActive] = React.useState<boolean>(false);

  function onClick() {
    let value = props.value + '';
    // 判断键盘类型
    // 如果是键盘的伸缩
    if (props.type === SLIDE) {
      // 转换为string
      value = '0';
      // // 改变键盘
      // setKeyStatus(!keyStatus);
    }
    // 调用父组件方法
    props.onKeyPress<string>(props.type, value);
  }

  function onTouchStart() {
    !props.disabled && setActive(true);
  }
  
  function onTouchEnd() {
    !props.disabled && setActive(false);
  }

  return (
    <div className={`keyboard-button ${props.className}`}>
      <button
        disabled={props.disabled}
        className={classnames({ active })}
        onClick={onClick}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onMouseDown={event =>  event.preventDefault()}
      >
        <span>{props.children}</span>
        {/* 只有在眼别切换时才显示 */}
        {
          props.type === EYE_TYPE_TOGGLE
          &&
          props.eyeType === props.value
          &&
          <b>·</b>
        }
      </button>
    </div>
  );
}